import assetInventory from './assetInventory'
import documents from './documents'
import privacyPortalTheme from './privacyPortalTheme'
import thirdPartyManagements from './thirdPartyManagements'
import tickets from './tickets'
import complaint from './complaint'

const tours = {
  assetInventory,
  documents,
  privacyPortalTheme,
  thirdPartyManagements,
  tickets,
  complaint,
}

export default tours
